import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, UNSAFE_NavigationContext } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { IoCloudUploadOutline } from "react-icons/io5";
import { RiImageAddFill } from "react-icons/ri";
import '../../../AdminStyle.css';
import { SuccessPopUp } from "../../../CommonComponents/SuccessPopUp";
import { uploadImage } from "../../../CommonComponents/ImageUpload";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import { MagnifyImage } from "../../../CommonComponents/MagnifyImage";

const useBlocker = (message, when) => {
    const { navigator } = React.useContext(UNSAFE_NavigationContext);

    useEffect(() => {
        if (!when) return;

        const originalPush = navigator.push;
        const originalReplace = navigator.replace;

        // Intercept navigation
        navigator.push = (...args) => {
            if (window.confirm(message)) {
                originalPush(...args);
            }
        };

        navigator.replace = (...args) => {
            if (window.confirm(message)) {
                originalReplace(...args);
            }
        };

        return () => {
            navigator.push = originalPush;
            navigator.replace = originalReplace;
        };
    }, [message, when, navigator]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (when) {
                event.preventDefault();
                event.returnValue = message;
                return message;
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [message, when]);
};

function UpdateItem() {

    const navigate = useNavigate();
    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');

    const [isDirty, setIsDirty] = useState(false);
    useBlocker('Are you sure you want to leave this page?', isDirty);

    // SUCCESS POPUP
    const [action, setAction] = useState();
    const [showPop, setShowPop] = useState(false);
    const [navv, setNavv] = useState();
    const [more, setMore] = useState();
    const navToCat = useNavigate();
    const confirmPopUp = () => {
        if (navv === 'ok') {
            setShowPop(false);
            navToCat(-1);
        } else if (navv === 'OK') {
            setShowPop(false);
        }
    };

    const onCloseBtn = () => {
        if (more === 'Add more') {
            setShowPop(false);
            setTitle('');
            setDescription('');
            setWeight('');
            setMrp('');
            setSequenceNo('');
            setSellingPrice('');
            setParentCategoryUuids('');
            setSubCategoryUuids('');
            setSubCat([]);
            if (subCat !== '') {
                setFilterSubCat([...subCat]);
                setManageSubCat([]);
            };
            window.scrollTo({
                top: 0,
                behavior: 'smooth'  // Optional: Use 'auto' for instant scroll
            });
        } else if (more === 'cancel') {
            navToCat('/admin/item');
        }
    };

    // UPDATE ITEM
    const location = useLocation();
    const product = location && location.state;

    const [title, setTitle] = useState(product.title);
    const [description, setDescription] = useState(product.description);
    const [customerDescription, setCustomerDescription] = useState(product.customerDescription);
    const [weight, setWeight] = useState(product.weight);
    const [mrp, setMrp] = useState(product.mrp);
    const [sequenceNo, setSequenceNo] = useState();
    const [sellingPrice, setSellingPrice] = useState(product.sellingPrice);
    const [parentCategoryUuids, setParentCategoryUuids] = useState(product.parentCategoryDetails?.map((itm) => ({ value: itm?.parentUuid, label: itm?.parentTitle })));
    const [subCategoryUuids, setSubCategoryUuids] = useState(product.subCategoryDetails?.map((itm) => ({ value: itm?.parentUuid, label: itm?.parentTitle })));
    const [imagePreviews, setImagePreviews] = useState(product.itemImageUrls?.map((itm) => itm));
    const [offerApplicable, setOfferApplicable] = useState(product.offerApplicable);
    const [taxUuid, setTaxUuid] = useState(product?.taxDetails && { value: product?.taxDetails?.parentUuid, label: product?.taxDetails?.parentTitle });
    const [publisherUuid, setPublisherUuid] = useState(product?.publisherDetails && { value: product?.publisherDetails?.parentUuid, label: product?.publisherDetails?.parentTitle });
    const [getMedium, setGetMedium] = useState({ value: 'aw2', label: product?.otherDataJson && JSON.parse(product?.otherDataJson).medium });
    const [otherDataJson, setOtherDataJson] = useState(product?.otherDataJson ? JSON.parse(product?.otherDataJson) : {
        medium: getMedium?.label || getMedium,
        author: "",
        noOfPages: "",
        publicationYear: "",
        hsnCode: "",
    });

    useEffect(() => {
        setOtherDataJson((prev) => ({
            ...prev, medium: getMedium?.label
        }))
    }, [getMedium]);

    const [selectMedium, setSelectMedium] = useState([
        { value: "1", label: "Hindi", },
        { value: "2", label: "English" },
        { value: "3", label: "Bilingual" },
        { value: "4", label: "Urdu" },
        { value: "5", label: "Sanskrit" },
    ]);

    const handleOnChange = (key, value) => {
        setIsDirty(true)
        setOtherDataJson((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    // HSN CODE 
    const [showHsnCode, setShowHsnCode] = useState(false);

    const [hsnCodeList, setHsnCodeList] = useState([
        "20", "25", "30", "35", "45", "4901"
    ]);

    const hsnRef = useRef();

    useEffect(() => {
        const handleOutSideClick = (event) => {
            if (!hsnRef.current?.contains(event.target)) {
                setShowHsnCode(false);
            }
        }
        document.addEventListener("mousedown", handleOutSideClick)
    }, [hsnRef]);


    const [filterHsnCode, setFilterHsnCode] = useState([...hsnCodeList]);

    const searchHsnCode = (text) => {
        setOtherDataJson((prev) => ({
            ...prev, hsnCode: +text
        }));
        const res = hsnCodeList.filter((itm) => itm.toString().includes(text));
        setFilterHsnCode(res);
        setShowHsnCode(true);
    };

    const content = {
        title: title,
        description: description,
        customerDescription: customerDescription,
        weight: weight,
        mrp: mrp,
        sequenceNo: sequenceNo,
        itemImageUrls: imagePreviews,
        sellingPrice: sellingPrice,
        parentCategoryUuids: parentCategoryUuids?.map(itm => itm.value),
        subCategoryUuids: subCategoryUuids?.map(itm => itm.value),
        offerApplicable: offerApplicable,
        taxUuid: taxUuid?.value,
        publisherUuid: publisherUuid?.value,
        otherDataJson: JSON.stringify(otherDataJson)
    };

    // SAVE ITEMS API
    const saveItem = async (uuid) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/item/update/${uuid}`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(content)
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setAction('your item updated successfully !');
                setShowPop(true);
                setNavv('ok');
                setMore('cancel');
            } else {
                setShowPop(true);
                setAction('something went wrong');
                setNavv('OK');
                setMore('cancel');
            }
        } catch (e) {
            console.log(e, "error in add itme api");
        }
    };

    // SELECT CATEGORY 
    const [seletedCat, setSelectedCat] = useState([]);
    const [filterCat, setFilterCat] = useState([]);

    const saveCat = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/category/parent-category-list-in-key-value`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setSelectedCat(getRes.responsePacket);
                setFilterCat(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, 'errorn in add item select parent cate api')
        }
    };

    useEffect(() => {
        const parentCategoryData = seletedCat.map((itm) => ({
            value: itm.value,
            label: itm.label,
        }));
        setFilterCat(parentCategoryData);
    }, [seletedCat]);

    useEffect(() => {
        saveCat();
    }, []);

    // SUB CATEGPRY
    const [subCat, setSubCat] = useState([]);
    const [filterSubCat, setFilterSubCat] = useState([]);
    useEffect(() => {
        if (subCat !== '') {
            setFilterSubCat([...subCat]);
        };
    }, []);

    const saveSub = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/category/sub-category-list-in-key-value`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    parentCategoryUuids: parentCategoryUuids?.map(itm => itm.value)
                })
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setSubCat(getRes.responsePacket);
                setFilterSubCat(getRes.responsePacket);
            } else {
                console.log('error in savasub api responce')
            }
        } catch (e) {
            console.log(e, 'error in sub category in add  item')
        }
    };
    useEffect(() => {
        if (parentCategoryUuids !== '') {
            saveSub();
        }
        if (parentCategoryUuids.length === 0) {
            setSubCat([]);
            setFilterSubCat([]);
            setManageSubCat([]);
            setSubCategoryUuids([]);
        }
    }, [parentCategoryUuids]);

    useEffect(() => {
        if (subCat?.length > 0) {
            const updatedManageSubCat = manageSubCat.filter((item) =>
                subCat.some((subItem) => subItem.value === item.value));
            const updateSubUuid = subCategoryUuids.filter((item) =>
                subCat.some((subItem) => subItem.value === item.value)
            )
            setSubCategoryUuids(updateSubUuid);
            setManageSubCat(updatedManageSubCat);
        }
    }, [subCat]);

    const [manageSubCat, setManageSubCat] = useState(product.subCategoryDetails);

    // UPLOAD IMGE
    const [loading, setLoading] = useState(false);
    const handleFileChange = async (e) => {
        setIsDirty(true);
        setLoading(true);
        try {
            const files = e.target.files;
            const validFiles = Array.from(files).filter((file) => {
                if (file.size > 100 * 1024) { // 100KB in bytes
                    alert(`${file.name} is too large (${file.size} bytes).`);
                    return false; // Exclude files larger than 100KB
                }
                return true; // Include files <= 100KB
            });
            for (const file of validFiles) {
                const imageUrl = await uploadImage(file);
                if (imageUrl) {
                    setImagePreviews((prev => prev ? [...prev, imageUrl.responsePacket] : [imageUrl.responsePacket]));
                }
            };
        } catch (e) {
            console.log(e, "error in image selection");
        } finally {
            setLoading(false);
            e.target.value = "";
        }
    };

    const handleDeleteImage = (index) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this item?");
        if (confirmDelete) {
            const newPreviews = imagePreviews.filter((_, i) => i !== index);
            setImagePreviews(newPreviews); // Update previews   
        }
    };

    const [errors, setErrors] = useState({});

    const titleRef = useRef(null);
    const mrpRef = useRef(null);
    const sellingPriceRef = useRef(null);
    const weightRef = useRef(null);
    const parentCateRef = useRef(null);
    const mediumReff = useRef(null);
    const publisherRef = useRef(null);
    const hsnCodeRef = useRef(null);
    const taxRef = useRef(null);

    const handleValidation = () => {
        let newErrors = {};
        if (!title?.trim()) newErrors.title = "Title is required.";
        if (parentCategoryUuids?.length === 0 && subCategoryUuids?.length === 0) newErrors.parentCategoryUuids = "tax Category is required.";
        if ((!mrp && mrp !== 0) || (typeof mrp === "string" && !mrp.trim()) || (typeof mrp === "number" && mrp <= 0) || Number(mrp) < Number(sellingPrice)) newErrors.mrp = "tax Category is required.";
        if ((!sellingPrice && sellingPrice !== 0) || (typeof sellingPrice === "string" && !sellingPrice.trim()) || (typeof sellingPrice === "number" && sellingPrice <= 0) || Number(sellingPrice) > Number(mrp)) newErrors.sellingPrice = "tax Category is required.";
        if ((!weight && weight !== 0) || (typeof weight === "string" && !weight.trim()) || (typeof weight === "number" && weight <= 0)) newErrors.weight = "tax Category is required.";
        if (!otherDataJson?.medium) newErrors.medium = "Medium is required.";
        if (!publisherUuid) newErrors.publisher = "Publisher is required.";
        if (!taxUuid) newErrors.taxCat = "tax Category is required.";
        if ((!otherDataJson?.hsnCode && otherDataJson?.hsnCode !== 0) || (typeof otherDataJson?.hsnCode === "string" && !otherDataJson?.hsnCode.trim()) || (typeof otherDataJson?.hsnCode === "number" && otherDataJson?.hsnCode <= 0)) newErrors.hsnCode = "HSN Code is required.";
        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            const firstErrorField = Object.keys(newErrors)[0];
            scrollToField(firstErrorField);
            return false;
        }
        return true;
    };

    const scrollToField = (field) => {
        switch (field) {
            case "title":
                titleRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "medium":
                mediumReff.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "publisher":
                publisherRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "hsnCode":
                hsnCodeRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "taxCat":
                taxRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "weight":
                weightRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "sellingPrice":
                sellingPriceRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "mrp":
                mrpRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "parentCategoryUuids":
                parentCateRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            default:
                break;
        }
    };

    const handleSubmit = () => {
        handleValidation();
        if (handleValidation()) {
            saveItem(product.uuid);
        }
    };

    const [publisherList, setPublisherList] = useState([]);
    const [filterPublisherList, setFilterPublisherList] = useState([...publisherList]);

    const getPublisherList = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/publisher/list-in-key-value`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setPublisherList(getRes.responsePacket);
                setFilterPublisherList(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, 'error in publisher api')
        }
    };
    useEffect(() => {
        getPublisherList();
    }, []);

    const [taxList, setTaxList] = useState([]);
    const [filtertaxList, setFilterTaxList] = useState([...taxList]);
    const getTaxList = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/tax/list-in-key-value`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setTaxList(getRes.responsePacket);
                setFilterTaxList(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, 'error in publisher api')
        }
    };
    useEffect(() => {
        getTaxList();
    }, []);

    // Image Magifinify
    const [imgUrl, setImgUrl] = useState();
    const [showImg, setShowImg] = useState(false);
    const maginifyImage = (e) => {
        setShowImg(true);
        setImgUrl(e);
    };

    return (
        <>
            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Update Item </h4>
                        </div>
                        <div className="category-btn">
                            <div className="btn submit-btn" style={{ marginTop: "0px" }}>
                                <button onClick={handleSubmit} style={{ backgroundColor: "black", color: "white", marginTop: "0px", marginRight: "25px" }}>Submit</button>
                            </div>
                            <button onClick={() => navigate("/admin/item")}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />

                    <div className="main-container">

                        <div className="add-form">
                            {/* Title Input */}
                            <div className="add w-100 m-b2" ref={titleRef}>
                                <label style={errors.title && { color: "red" }}>Title *</label>
                                <input
                                    type="text"
                                    name="title"
                                    value={title}
                                    onChange={(e) => { setTitle(e.target.value); setIsDirty(true) }}
                                />
                            </div>

                            {/* Category Input */}
                            <div className="d-flex w-100 m-b2 d-other" ref={parentCateRef}>
                                <div className="add parentid">
                                    <label style={errors.parentCategoryUuids && { color: "red" }}>Category</label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        isMulti
                                        name="colors"
                                        options={filterCat.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={parentCategoryUuids}
                                        onChange={(e) => { setParentCategoryUuids(e); setIsDirty(true) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />

                                </div>

                                <div className="add parentid">
                                    <label style={errors.parentCategoryUuids && { color: "red" }}>Select Sub Category</label>

                                    <Select
                                        closeMenuOnSelect={false}
                                        isMulti
                                        name="colors"
                                        options={filterSubCat.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={subCategoryUuids}
                                        onChange={(e) => { setSubCategoryUuids(e); setIsDirty(true) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />

                                </div>
                            </div>

                            {/* MRP Input */}
                            <div className="d-flex w-100 m-b2 d-other" ref={mrpRef}>
                                <div className="add">
                                    <label style={errors.mrp && { color: "red" }}>MRP *</label>
                                    <input
                                        type="number"
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        // placeholder="MRP"
                                        value={mrp}
                                        onChange={(e) => { setMrp(e.target.value); setIsDirty(true) }}
                                    />
                                </div>
                                <div className="add" ref={sellingPriceRef}>
                                    <label style={errors.sellingPrice && { color: "red" }}>Selling Price *</label>
                                    <input
                                        type="number"
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        // placeholder="Selling Price"
                                        onChange={(e) => { setSellingPrice(e.target.value); setIsDirty(true) }}
                                        value={sellingPrice}
                                    />
                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add">
                                    <div className="d-flex check-box-avail">
                                        <input
                                            type="checkbox"
                                            name="availableAllTime"
                                            checked={offerApplicable}
                                            onChange={() => { setOfferApplicable(!offerApplicable); setIsDirty(true) }}
                                            id="check-box"
                                        />
                                        <label htmlFor="check-box">Coupon available for item</label>
                                    </div>
                                </div>

                                <div className="add" ref={weightRef}>
                                    <label style={errors.weight && { color: "red" }}>Weight *</label>
                                    <div className="btn-AddCat">
                                        <input
                                            type="number"
                                            onChange={(e) => { setWeight(e.target.value); setIsDirty(true) }}
                                            value={weight}
                                            onKeyDown={(e) => {
                                                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                        <button>gm</button>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add parentid" ref={mediumReff}>
                                    <label style={errors.medium && { color: "red" }}>Medium *</label>

                                    <Select
                                        closeMenuOnSelect={true}
                                        name="colors"
                                        options={selectMedium.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={getMedium}
                                        onChange={(e) => { setGetMedium(e); setIsDirty(true) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />

                                </div>

                                <div className="add parentid" ref={publisherRef}>
                                    <label style={errors.publisher && { color: "red" }}>Publisher *</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        name="colors"
                                        options={filterPublisherList.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={publisherUuid}
                                        onChange={(e) => { setPublisherUuid(e); setIsDirty(true) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />
                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other">

                                <div className="add ">
                                    <label>Author</label>
                                    <input
                                        type="text"
                                        value={otherDataJson.author}
                                        onChange={(e) => handleOnChange("author", e.target.value)}
                                    />
                                </div>

                                <div className="add ">
                                    <label>No. of Pages</label>
                                    <input
                                        type="number"
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        value={otherDataJson.noOfPages}
                                        onChange={(e) => handleOnChange("noOfPages", e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add">
                                    <label>Publication Year</label>
                                    <input
                                        type="number"
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        value={otherDataJson.publicationYear}
                                        onChange={(e) => handleOnChange("publicationYear", e.target.value)}
                                    />

                                </div>

                                <div className="add parentid" ref={taxRef}>
                                    <label style={errors.taxCat && { color: "red" }}>Tax Category *</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        name="colors"
                                        options={filtertaxList.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={taxUuid}
                                        onChange={(e) => { setTaxUuid(e); setIsDirty(true) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />
                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add parentid" ref={hsnCodeRef}>
                                    <label style={errors.hsnCode && { color: "red" }}>HSN Code *</label>
                                    <input
                                        type="number"
                                        onKeyDown={(e) => {
                                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        value={otherDataJson.hsnCode}
                                        onChange={(e) => { handleOnChange("hsnCode", e.target.value); searchHsnCode(e.target.value) }}
                                        onClick={() => setShowHsnCode(!showHsnCode)}
                                    />

                                </div>
                            </div>

                            <div className="editer m-b2">
                                <div className="add w-100">
                                    <label>Key Words</label>

                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: {
                                                items: [
                                                    "heading",
                                                    "|",
                                                    "bold",
                                                    "italic",
                                                    "link",
                                                    "bulletedList",
                                                    "numberedList",
                                                    "|",
                                                    "indent",
                                                    "outdent",
                                                    "|",
                                                    "imageUpload",
                                                    "blockQuote",
                                                    "mediaEmbed",
                                                    "undo",
                                                    "redo",
                                                ],
                                            },
                                        }}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDescription(data);
                                            setIsDirty(true)
                                        }}
                                    />

                                </div>
                            </div>
                            <div className="editer m-b2">
                                <div className="add w-100">
                                    <label>Description</label>

                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: {
                                                items: [
                                                    "heading",
                                                    "|",
                                                    "bold",
                                                    "italic",
                                                    "link",
                                                    "bulletedList",
                                                    "numberedList",
                                                    "|",
                                                    "indent",
                                                    "outdent",
                                                    "|",
                                                    "imageUpload",
                                                    "blockQuote",
                                                    "mediaEmbed",
                                                    "undo",
                                                    "redo",
                                                ],
                                            },
                                        }}
                                        data={customerDescription}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setCustomerDescription(data);
                                            setIsDirty(true)
                                        }}
                                    />

                                </div>
                            </div>

                            <div className="add w-100">
                                <label>Item Image</label>
                                <div className="input-img">
                                    <input
                                        type="file"
                                        onChange={handleFileChange}
                                        multiple
                                        id="category-icon"
                                        style={{ display: 'none' }}
                                    />
                                    {
                                        imagePreviews?.length > 0 ?

                                            (
                                                loading ?
                                                    <div className="loading-container">
                                                        <div className="spinner"></div>
                                                        <p>Loading...</p>
                                                    </div>
                                                    :
                                                    <label htmlFor="category-icon" tabIndex="0" onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            document.getElementById("category-icon").click();
                                                        }
                                                    }}>
                                                        <div className="custom-label">
                                                            <RiImageAddFill />
                                                            <span>Add more</span>
                                                        </div>
                                                    </label>
                                            )
                                            :
                                            (
                                                loading ?
                                                    <div className="loading-container">
                                                        <div className="spinner"></div>
                                                        <p>Loading...</p>
                                                    </div>
                                                    :
                                                    <label htmlFor="category-icon" className="custom-file-input" tabIndex="0" onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            document.getElementById("category-icon").click();
                                                        }
                                                    }}>
                                                        <div className="text">
                                                            <div className="icon">
                                                                <h1><IoCloudUploadOutline /></h1>
                                                                <h4>Add Images</h4>
                                                            </div>
                                                        </div>
                                                    </label>
                                            )
                                    }

                                </div>

                                {/* Image Preview Section */}
                                {
                                    imagePreviews?.length > 0 && !loading && (
                                        <div className="image-preview-wrapper">
                                            {
                                                imagePreviews?.map((preview, index) => (
                                                    <div key={index} className="image-preview-container">
                                                        <img
                                                            src={preview}
                                                            alt={`Category Icon ${index + 1}`}
                                                            style={{ objectFit: 'cover' }}
                                                            onClick={() => maginifyImage(preview)}
                                                            loading="lazy"
                                                        />

                                                        {/* Delete Button */}
                                                        <button
                                                            type="button"
                                                            onClick={() => handleDeleteImage(index)}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '-5px',
                                                                left: '-5px',
                                                                background: 'red',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '50%',
                                                                width: '25px',
                                                                height: '25px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            X
                                                        </button>
                                                    </div>
                                                ))}
                                        </div>
                                    )
                                }
                            </div>

                        </div>

                        {/* <div className="btn submit-btn" style={{ justifyContent: "flex-start" }}>
                            <button onClick={() => handleSubmit()}>Submit</button>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* POPUP MODAL */}

            <SuccessPopUp
                isOpen={showPop}
                action={action}
                navv={navv}
                // FutherMore={more}
                onClose={onCloseBtn}
                onConfirm={confirmPopUp}
            />

            <MagnifyImage isOpen={showImg} imgSrc={imgUrl} onClose={() => setShowImg(false)} />
        </>
    );
}

export default UpdateItem;